// extracted by mini-css-extract-plugin
export default {"solvingTime":"SolvingTime_solvingTime__mQzrx"};